import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core'
import { UntypedFormControl, UntypedFormGroup, Validators } from "@angular/forms"
import { MomentDateAdapter } from "@angular/material-moment-adapter"
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from "@angular/material/core"
import { MatPaginator } from "@angular/material/paginator"
import { MatSort } from "@angular/material/sort"
import { MatTableDataSource } from "@angular/material/table"
import * as moment from 'moment'
import { Subscription } from "rxjs"
import { debounceTime } from "rxjs/operators"
import { ClientService } from '../../shared/client/client.service'
import { CUSTOM_DATE_FORMAT } from "../../shared/datepicker/datepicker-format"
import { LectureCab } from "../shared/lecture-cab"
import { LectureCabService } from "../shared/lecture-cab.service"
import { Client } from '../../shared/client/client'

@Component({
  selector: 'app-lecture-bilan',
  templateUrl: './lecture-bilan.component.html',
  styleUrls: ['./lecture-bilan.component.scss'],
  providers: [
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE], },
    { provide: MAT_DATE_FORMATS, useValue: CUSTOM_DATE_FORMAT },
    { provide: MAT_DATE_LOCALE, useValue: 'fr-FR' }
  ]
})
export class LectureBilanComponent implements OnInit, OnDestroy {
  subClient: Subscription
  currentClient: Client
  lecture
  lectureEtapes
  loading: boolean = false
  load: Subscription = new Subscription()
  lectureForm: UntypedFormGroup = new UntypedFormGroup({
    'date-min': new UntypedFormControl(new Date(new Date(new Date().setDate(new Date().getDate() - 8)).setHours(0, 0, 0, 0)), [
      Validators.required
    ]),
    'date-max': new UntypedFormControl(new Date(new Date().setHours(0, 0, 0, 0)), [
      Validators.required
    ]),
    'type': new UntypedFormControl('0', [
      Validators.required
    ]),
    'comptes': new UntypedFormControl('c', [
      Validators.required
    ]),
    'porteur': new UntypedFormControl('', [
    ]),
  })
  dataSource: MatTableDataSource<LectureCab> = new MatTableDataSource<LectureCab>()
  // Colonnes
  columns = [
    { id: 'dateLecture', libelle: 'Date lecture' },
    { id: 'type', libelle: 'Etape' },
    { id: 'compte', libelle: 'Compte' },
    { id: 'codeArticle', libelle: 'Code article' },
    { id: 'designation', libelle: 'Désignation article' },
    { id: 'nbVts', libelle: 'Nombre Vts' }
  ]
  displayedColumns: Array<string> = ['dateLecture', 'type', 'compte', 'codeArticle', 'designation', 'nbVts']
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator
  @ViewChild(MatSort, { static: true }) sort: MatSort
  constructor(private lectureCabService: LectureCabService, private clientService: ClientService) { }

  ngOnDestroy(): void {
    this.load.unsubscribe()
    if (this.subClient) {
      this.subClient.unsubscribe()
    }
  }

  ngOnInit() {
    this.subClient = this.clientService.getCurrentClient().subscribe(client => {
      this.load.closed = false
      this.currentClient = client;
      this.lectureForm.get('date-min').setValue(new Date(new Date(new Date().setDate(new Date().getDate() - 8)).setHours(0, 0, 0, 0)))
      this.lectureForm.get('date-max').setValue(new Date(new Date().setHours(0, 0, 0, 0)))

      this.lectureCabService.getLectureCabEtapes().subscribe(res => {
        this.lectureEtapes = res
      })

      this.load = this.lectureCabService.getBilan(this.currentClient, this.lectureForm.value).subscribe(res => {
        this.dataSource.data = res
      })

      this.load.closed = true
    })
  }

  ngAfterContentInit() {
    this.lectureForm.valueChanges.subscribe(dataChange => {
      if (this.load.closed) {
        this.load = this.lectureCabService.getBilan(this.currentClient, dataChange).subscribe(res => {
          this.dataSource.data = res
          this.load.closed = true
        })
      }
    })

    this.dataSource.paginator = this.paginator
    this.dataSource.sort = this.sort
    this.dataSource.sortingDataAccessor = (item, property) => {
      switch (property) {
        case 'dateLecture': {
          return moment(item.dateLecture, "DD/MM/YYYY")
        }
        default: {
          return item[property]
        }
      }
    }
  }

  exportBilan() {
    this.loading = true
    this.load = this.lectureCabService.exportBilan(this.lectureForm.value).subscribe(response => this.loading = false, error => this.loading = false)
  }
}
